import Repository from "./Repository";

const formDataConfig = {
  headers: { "Content-Type": "multipart/form-data" },
};

const ADD_ABOUTUS = "aboutus/create";
const DELETE_ABOUTUS = "aboutus/delete";
const GET_ABOUTUS = "aboutus/getall";
const UPDATE_ABOUTUS = "aboutus/update";

export default {
  add_aboutUs(payload) {
    return Repository.post(transformRoute(ADD_ABOUTUS), payload);
  },
  delete_aboutUs(payload) {
    return Repository.post(transformRoute(DELETE_ABOUTUS), payload);
  },
  getall_aboutUs(payload) {
    return Repository.get(transformRoute(GET_ABOUTUS), { params: payload });
  },
  update_aboutUs(payload) {
    return Repository.post(transformRoute(UPDATE_ABOUTUS), payload);
  },

  ////////////////////////
  ////////////////////////
};

const transformRoute = (route) => {
  return `homepage/${route}`;
};
